import * as React from 'react';
export const bankLightningSvg = React.forwardRef(function bankLightningSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.6 5.337a.75.75 0 0 1 .313 1.014L13.246 9.5h1.34a1 1 0 0 1 .885 1.466l-2.307 4.383a.75.75 0 1 1-1.328-.698L13.758 11h-1.343a1 1 0 0 1-.884-1.468l2.056-3.883a.75.75 0 0 1 1.014-.312Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.674.075a.75.75 0 0 1 .638-.007l6 2.75a.75.75 0 0 1-.624 1.364l-5.68-2.603L1.5 4.72v.78h8c.043 0 .084.004.125.01a.75.75 0 0 1 .875.74v6a.75.75 0 0 1-1.5 0V7H7v5.25a.75.75 0 0 1-1.5 0V7H4v5.25a.75.75 0 0 1-.415.67L1.5 13.964v.537h8.25a.75.75 0 0 1 0 1.5H1a1 1 0 0 1-1-1v-1.345a1 1 0 0 1 .553-.895l1.947-.973V7H1a1 1 0 0 1-1-1V4.407a1 1 0 0 1 .565-.9L7.674.074Z',
    }),
  );
});
bankLightningSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bankLightning = {
  category: 'icon',
  colorable: true,
  name: 'bankLightning',
  svg: bankLightningSvg,
};
